export enum PosthogEvent {
  ClosedModal = "Closed Modal",
  WalletConnected = "Walled Connected",
}
